import { makeStyles } from '@mui/styles';
import { colors } from '../../../packages';

export const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    flex: 1,
    minHeight: 0,
    padding: '24px',
    gap: '24px',
  },
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    minHeight: 0,
    overflow: 'hidden',
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    gap: '16px',
    padding: '16px',
    backgroundColor: colors.white,
    borderRadius: '16px',
    border: `1px solid ${colors.neutral100}`,
    boxShadow:
      '0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.06), 0px 0px 1px 0px rgba(0, 0, 0, 0.04)',
    flexShrink: 0,
  },
  input: {
    height: '48px',
    display: 'flex',
    justifyContent: 'center',
    flex: 1,
    borderRadius: '8px',
    border: 'none',
    padding: '12px 16px',
  },
  button: {
    minWidth: '48px',
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    color: colors.neutral900,
    backgroundColor: colors.neutral100,
    borderRadius: '8px',
    border: 'none',
    flexShrink: 0,
    '&.Mui-disabled': {
      color: colors.neutral400,
      backgroundColor: colors.neutral50,
    },
    '&:not(.Mui-disabled):hover': {
      backgroundColor: colors.neutral200,
    },
  },
  error: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    border: `1px solid ${colors.destructive500}`,
    borderRadius: '4px',
    backgroundColor: colors.destructive50,
    padding: '24px',
  },
  errorHeading: {
    fontSize: '16px',
    color: colors.destructive700,
  },
  loaderContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: '16px 0px',
    gap: '16px',
    alignItems: 'center',
  },
  loaderText: { color: colors.secondary500, fontSize: '14px', fontWeight: 700 },
  loaderIcon: { width: '32px', height: '32px' },
  inputContainer: {
    display: 'flex',
    gap: '12px',
    width: '100%',
    alignItems: 'center',
  },
});

export const sxStyles = {
  conversationContainer: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  conversationHistory: {
    padding: '16px',
    flex: 1,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  messageContainer: {
    maxWidth: '80%',
    padding: '8px 12px',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
  },
  sentMessage: {
    alignSelf: 'flex-end',
    backgroundColor: colors.white,
    border: `1px solid ${colors.neutral200}`,
    color: colors.neutral900,
  },
  receivedMessage: {
    alignSelf: 'flex-start',
    backgroundColor: colors.white,
    color: colors.neutral900,
  },
  copilotSection: {
    width: '100%',
    marginTop: '8px',
  },
  copilotOptions: {
    display: 'flex',
    gap: '10px',
    width: '100%',
    flexWrap: 'wrap',
  },
  optionButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '4px 8px',
    borderRadius: '20px',
    border: `1px solid ${colors.neutral200}`,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    lineHeight: 1,
    backgroundColor: colors.white,
    '&:hover': {
      borderColor: colors.primary300,
    },
  },
  optionButtonSelected: {
    backgroundColor: colors.primary500,
    border: 'none',
    '&:hover': {
      backgroundColor: colors.primary600,
    },
  },
  optionButtonDisabled: {
    cursor: 'default',
    pointerEvents: 'none',
    '&:hover': {
      borderColor: colors.neutral300,
    },
  },
};
